import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DomSanitizer } from "@angular/platform-browser";
import { DataService } from "../../services/data.service"
import { InProductsService } from "../../services/inventory/in-products.service";
import { AuthenticationService } from "../../services/authentication.service";
import { environment } from "../../../../environments/environment";

export interface CurrencyItems {
  title: string;
  Items: any;
}

@Component({
  selector: 'app-currency-popup',
  templateUrl: './currency-popup.component.html',
  styleUrls: ['./currency-popup.component.css']
})
export class CurrencyPopUpComponent extends DialogComponent<CurrencyItems, boolean>
  implements CurrencyItems, OnInit, OnChanges {

  title: string;
  Items: any = [];
  result: any = { result: false, RtnItem: {} };
  @Input() popup: boolean = true;

  modelCurrency = new Currency_Model();

  loading: boolean = false
  @Output() emitCurrency = new EventEmitter();
  @Input() currencyModel: Currency_Model;

  isedit: boolean = false;
  Access: any;

  constructor(dialogService: DialogService, private ds: DataService, private ips: InProductsService) {
    super(dialogService);
  }

  ngOnChanges() {
    if (this.currencyModel.Id != 0) {
      this.modelCurrency.Id = this.currencyModel.Id;
      this.modelCurrency.Name = this.currencyModel.Name;
      this.modelCurrency.Symbol = this.currencyModel.Symbol;
      this.modelCurrency.Integerpartcaption = this.currencyModel.Integerpartcaption;
      this.modelCurrency.Decimalpartcaption = this.currencyModel.Decimalpartcaption;
      this.modelCurrency.NoofDecimal = this.currencyModel.NoofDecimal;
      this.modelCurrency.Description = this.currencyModel.Description;
      this.modelCurrency.ExchangeRate = this.currencyModel.ExchangeRate;
      this.isedit = true;
    }
  }
  ngOnInit() {
    this.clear();
    this.Access = this.ds.Access["Currency Master"];
  }

  validCurrency(): boolean {
    if (this.modelCurrency.Name == "") {
      alert("Please enter Short Name");
      return false;
    }
    if (this.modelCurrency.Symbol == "") {
      alert("Please enter Symbol");
      return false;
    }
    return true;
  }

  saveCurrency() {
    if (this.validCurrency()) {
      this.loading = true;
      this.modelCurrency.UserId = this.ds.Settings.UserId;
      if (this.modelCurrency.Id == 0 || this.modelCurrency.Id == null) {
        this.ips.Save_CurrencyMaster(this.modelCurrency).subscribe(res => {
          if (res.Success) {
            alert("Currency Saved Successfully");
            this.modelCurrency = new Currency_Model();
            this.result.result = true;
            this.emitCurrencyList();
            this.isedit = false;
            this.loading = false;
          }
          else {
            alert(res.error.UsrMsg);
            this.isedit = false;
            this.loading = false;
          }
        })
      }
      else {
        this.ips.Update_CurrencyMaster(this.modelCurrency).subscribe(res => {
          if (res.Success) {
            alert("Currency Updated Successfully");
            this.modelCurrency = new Currency_Model();
            this.result.result = true;
            this.emitCurrencyList();
            this.isedit = false;
            this.loading = false;
          }
          else {
            alert(res.error.UsrMsg);
            this.loading = false;
          }
        })
      }
    }

  }

  emitCurrencyList() {
    this.emitCurrency.emit(null);
  }

  clear() {
    this.modelCurrency = new Currency_Model();
    this.isedit = false;
  }
  cancel() {
    this.modelCurrency = new Currency_Model();
    this.close();
  }

  shortnameKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("symbol").focus();
    }
  }

  symbolKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("description").focus();
    }
  }

  descriptionKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("integerpartcaption").focus();
    }
  }

  integerpartcaptionKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("decimalpartcaption").focus();
    }
  }

  decimalpartcaptionKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      document.getElementById("noofDecimal").focus();
    }
  }

  noofDecimalKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      //document.getElementById("noofDecimal").focus();
    }
  }

  saveEditAccessPremission(Access: any, edit: boolean): boolean {
    Access = this.ds.Access["Currency Master"]
    if (Access == undefined) {
      return false;
    }
    if (edit) {
      return !Access.edit
    }
    else {
      return !Access.save
    }
  }

}

class Currency_Model {
  Id: number;
  Name: string = "";
  Symbol: string = "";
  Integerpartcaption: string = "";
  Decimalpartcaption: string = "";
  NoofDecimal: number = 0;
  Description: string = "";
  ExchangeRate: number = 0;
  UserId: number = 0;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/currency-popup/currency-popup.component.ts